window.scrollTo(0, 0)

import gsap from 'gsap';
import Lenis from 'lenis';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { initBarba } from './barba';
import { initProjectPrefetch } from './animations/prefetch';

gsap.registerPlugin(ScrollTrigger, CSSPlugin);

// Optionnel : Rend ScrollTrigger accessible globalement pour le debug console
window.ScrollTrigger = ScrollTrigger; 



if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

export const lenis = new Lenis({
    duration: 1.2,
    lerp: 0.1,
    smoothWheel: true,
    syncTouch: true
});

// Update ScrollTrigger à chaque scroll de Lenis
lenis.on('scroll', ScrollTrigger.update);

// Synchronisation du ticker GSAP avec Lenis
gsap.ticker.add((time) => { 
    lenis.raf(time * 1000); 
});

// Désactiver le lagSmoothing pour éviter les sauts de scroll après une transition
gsap.ticker.lagSmoothing(0);

// On bloque le scroll au démarrage (sera débloqué par barba.once)
lenis.stop();

const originalFromTo = gsap.fromTo.bind(gsap);
gsap.fromTo = (targets, ...args) => {
    if (!targets || (targets.length !== undefined && targets.length === 0)) {
        console.trace('gsap.fromTo appelé avec target null/vide:', targets);
    }
    return originalFromTo(targets, ...args);
};



// Rechargement de page : on mémorise la position pour la rétablir (voir barba.js → once)
window.addEventListener('pagehide', () => {
    try {
        sessionStorage.setItem('cs_reload', JSON.stringify({ path: location.pathname, y: window.scrollY }));
    } catch (e) { /* stockage indisponible : on repartira en haut de page */ }
});

// On lance Barba en passant l'instance de Lenis
initBarba(lenis);

// Préchargement des projets au survol (une seule fois pour tout le site)
initProjectPrefetch();